<div class="template-form-grid">
  <!-- COLUMNA IZQUIERDA: Formulario -->
  <div class="form-column">
    <form [formGroup]="form">
      <p-tabView [(activeIndex)]="activeTabIndex">
        
        <!-- Tab 1: Información Básica -->
        <p-tabPanel header="Información Básica">
      <div class="grid">
        <div class="col-12 md:col-6">
          <label for="name">Nombre <span class="text-red-500">*</span></label>
          <input 
            id="name" 
            type="text" 
            pInputText 
            formControlName="name" 
            placeholder="Ej: Recordatorio de pago amigable"
            class="w-full"
          />
          <small class="text-red-500" *ngIf="form.get('name')?.invalid && form.get('name')?.touched">
            El nombre es requerido (máximo 200 caracteres)
          </small>
        </div>
        
        <div class="col-12">
          <label for="description">Descripción</label>
          <textarea 
            id="description" 
            pInputTextarea 
            formControlName="description" 
            rows="3"
            placeholder="¿Cuándo usar esta plantilla? Ej: Para clientes Premium con mora menor a 7 días, tono amigable y profesional"
            class="w-full"
          ></textarea>
          <small class="text-gray-500">Documenta el contexto de uso y casos aplicables (máximo 500 caracteres)</small>
        </div>
      </div>
    </p-tabPanel>
    
    <!-- Tab 2: Email (REQUERIDO) -->
    <p-tabPanel header="Email *">
      <div formGroupName="emailTemplate">
        <div class="grid">
          <div class="col-12">
            <div class="flex justify-content-between align-items-center mb-2">
              <label for="emailSubject">Asunto <span class="text-red-500">*</span></label>
              <small class="text-gray-500">
                <i class="pi pi-info-circle"></i> Usa variables dinámicas (clic en panel derecho)
              </small>
            </div>
            <input 
              id="emailSubject" 
              type="text" 
              pInputText 
              formControlName="subject" 
              placeholder="Ej: Recordatorio: Tu pago vence pronto"
              class="w-full"
              (focus)="setActiveField('emailTemplate.subject', $event)"
              (click)="updateCursorPosition()"
              (keyup)="updateCursorPosition()"
            />
            <small class="text-red-500" *ngIf="emailTemplate.get('subject')?.invalid && emailTemplate.get('subject')?.touched">
              El asunto es requerido (máximo 200 caracteres)
            </small>
          </div>
          
          <div class="col-12 mt-3">
            <div class="flex justify-content-between align-items-center mb-2">
              <label for="emailHtml">Contenido HTML <span class="text-red-500">*</span></label>
              <small class="text-gray-500">
                <i class="pi pi-info-circle"></i> Usa variables dinámicas (clic en panel derecho)
              </small>
            </div>
            <textarea 
              id="emailHtml" 
              pInputTextarea 
              formControlName="html" 
              rows="10"
              placeholder="Escribe el contenido HTML del email aquí..."
              class="w-full"
              (focus)="setActiveField('emailTemplate.html', $event)"
              (click)="updateCursorPosition()"
              (keyup)="updateCursorPosition()"
            ></textarea>
            <small class="text-red-500" *ngIf="emailTemplate.get('html')?.invalid && emailTemplate.get('html')?.touched">
              El contenido HTML es requerido
            </small>
          </div>
        </div>
      </div>
    </p-tabPanel>
    
    <!-- Tab 3: SMS (OPCIONAL) -->
    <p-tabPanel header="SMS">
      <div formGroupName="smsTemplate">
        <div class="grid">
          <div class="col-12">
            <div class="flex justify-content-between align-items-center mb-2">
              <label for="smsMessage">Mensaje SMS</label>
              <small class="text-gray-500">
                <i class="pi pi-info-circle"></i> Máximo 160 caracteres (sin tildes ni emojis)
              </small>
            </div>
            <textarea 
              id="smsMessage" 
              pInputTextarea 
              formControlName="message" 
              rows="4"
              maxlength="160"
              placeholder="Ej: Hola clientName, pago $amount vence dueDate (usa variables del panel derecho)"
              class="w-full"
              (focus)="setActiveField('smsTemplate.message', $event)"
              (click)="updateCursorPosition()"
              (keyup)="updateCursorPosition()"
              (input)="onSmsMessageInput($event)"
            ></textarea>
            
            <!-- Contador inteligente con sanitización -->
            <app-sms-character-counter 
              [message]="smsTemplate.get('message')?.value || ''">
            </app-sms-character-counter>
            
            <small class="text-red-500 block mt-2" *ngIf="smsTemplate.get('message')?.hasError('maxlength')">
              Máximo 160 caracteres
            </small>
            
            <!-- Explicación de la sanitización automática -->
            <div class="sms-sanitization-notice mt-2">
              <div class="notice-box">
                <i class="pi pi-shield"></i>
                <div>
                  <strong>Sanitización automática activada</strong>
                  <small>Las tildes, emojis y caracteres especiales se convierten automáticamente a texto compatible con SMS (GSM-7). Esto garantiza que los mensajes lleguen en 1 solo SMS sin fragmentación.</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    
    <!-- Tab 4: WhatsApp (OPCIONAL) -->
    <p-tabPanel header="WhatsApp">
      <div formGroupName="whatsappTemplate">
        <div class="grid">
          <div class="col-12">
            <div class="flex justify-content-between align-items-center mb-2">
              <label for="whatsappMessage">Mensaje WhatsApp</label>
              <small class="text-gray-500">
                <i class="pi pi-info-circle"></i> Usa emojis para mejor engagement
              </small>
            </div>
            <textarea 
              id="whatsappMessage" 
              pInputTextarea 
              formControlName="message" 
              rows="5"
              placeholder="Ej: ¡Hola! 👋 Te recordamos que tienes un pago pendiente..."
              class="w-full"
              (focus)="setActiveField('whatsappTemplate.message', $event)"
              (click)="updateCursorPosition()"
              (keyup)="updateCursorPosition()"
            ></textarea>
          </div>
        </div>
      </div>
    </p-tabPanel>
    
    <!-- Tab 5: Llamadas (OPCIONAL) -->
    <p-tabPanel header="Llamadas">
      
      <!-- SECCIÓN 1: Llamada Automatizada (Dialer TTS/Audio) -->
      <div class="call-section mb-4">
        <h4 class="section-title">
          <i class="pi pi-phone"></i>
          Llamada Automatizada (Dialer)
        </h4>
        <p class="section-description text-gray-500 mb-3">
          Configura mensajes de voz automáticos que el sistema enviará sin intervención humana.
        </p>
        
        <div formGroupName="autoCallConfig">
          <!-- Selector de tipo -->
          <div class="grid mb-3">
            <div class="col-12">
              <label class="block mb-2">Tipo de Llamada</label>
              <p-selectButton 
                [options]="callTypeOptions"
                formControlName="callType"
                optionLabel="label"
                optionValue="value">
              </p-selectButton>
            </div>
          </div>
          
          <!-- Opción TTS -->
          <div *ngIf="autoCallConfig.get('callType')?.value === 'TTS'" class="grid">
            <div class="col-12">
              <div class="flex justify-content-between align-items-center mb-2">
                <label for="ttsMessage">Mensaje de Voz</label>
                <small class="text-gray-500">
                  <i class="pi pi-info-circle"></i> Máximo 2000 caracteres. Usa variables dinámicas.
                </small>
              </div>
              <textarea 
                id="ttsMessage" 
                pInputTextarea 
                formControlName="ttsMessage" 
                rows="4"
                maxlength="2000"
                [placeholder]="'Ej: Hola {{clientName}}, le recordamos que tiene un pago pendiente de {{amount}} pesos con vencimiento el {{dueDate}}.'"
                class="w-full"
                (focus)="setActiveField('autoCallConfig.ttsMessage', $event)"
                (click)="updateCursorPosition()"
                (keyup)="updateCursorPosition()"
              ></textarea>
              <div class="flex justify-content-between mt-1">
                <small class="text-gray-500">
                  {{ (autoCallConfig.get('ttsMessage')?.value || '').length }}/2000 caracteres
                </small>
                <small class="text-gray-500">
                  <i class="pi pi-volume-up"></i> Voz femenina en español
                </small>
              </div>
            </div>
          </div>
          
          <!-- Opción Audio Pregrabado -->
          <div *ngIf="autoCallConfig.get('callType')?.value === 'AUDIO'" class="grid">
            <div class="col-12">
              <div class="flex justify-content-between align-items-center mb-2">
                <label>Archivo de Audio</label>
                <small class="text-gray-500">
                  <i class="pi pi-info-circle"></i> Formatos: MP3, WAV. Máximo 10MB.
                </small>
              </div>
              
              <!-- Uploader -->
              <div class="audio-uploader" *ngIf="!autoCallConfig.get('audioUrl')?.value && !selectedAudioFile">
                <input 
                  type="file" 
                  accept="audio/mpeg,audio/wav,audio/mp3"
                  (change)="onAudioFileSelected($event)"
                  #audioInput
                  style="display: none"
                />
                <button 
                  pButton 
                  type="button"
                  label="Seleccionar Audio"
                  icon="pi pi-upload"
                  class="p-button-outlined"
                  (click)="audioInput.click()">
                </button>
              </div>
              
              <!-- Preview del archivo seleccionado (antes de subir) -->
              <div class="audio-preview" *ngIf="selectedAudioFile && !autoCallConfig.get('audioUrl')?.value">
                <div class="flex align-items-center gap-3 p-3 surface-100 border-round">
                  <i class="pi pi-file-audio text-2xl text-primary"></i>
                  <div class="flex-1">
                    <div class="font-medium">{{ selectedAudioFile.name }}</div>
                    <small class="text-gray-500">{{ (selectedAudioFile.size / 1024).toFixed(1) }} KB</small>
                  </div>
                  <audio controls class="audio-player">
                    <source [src]="audioPreviewUrl" [type]="selectedAudioFile.type">
                  </audio>
                  <button 
                    pButton 
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger p-button-text"
                    (click)="clearAudio()"
                    pTooltip="Eliminar">
                  </button>
                </div>
                
                <!-- Botón para subir -->
                <button 
                  pButton 
                  type="button"
                  label="Subir Audio"
                  icon="pi pi-cloud-upload"
                  class="p-button-success mt-2"
                  [loading]="isUploadingAudio"
                  (click)="uploadAudio()">
                </button>
              </div>
              
              <!-- Audio ya subido -->
              <div class="audio-uploaded" *ngIf="autoCallConfig.get('audioUrl')?.value">
                <div class="flex align-items-center gap-3 p-3 surface-100 border-round">
                  <i class="pi pi-check-circle text-2xl text-green-500"></i>
                  <div class="flex-1">
                    <div class="font-medium">{{ autoCallConfig.get('audioFileName')?.value }}</div>
                    <small class="text-green-600">Audio subido correctamente</small>
                  </div>
                  <audio controls class="audio-player">
                    <source [src]="autoCallConfig.get('audioUrl')?.value" type="audio/mpeg">
                  </audio>
                  <button 
                    pButton 
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger p-button-text"
                    (click)="clearAudio()"
                    pTooltip="Eliminar y subir otro">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <p-divider></p-divider>
      
      <!-- SECCIÓN 2: Script de Llamada Manual (para agentes) -->
      <div class="call-section">
        <h4 class="section-title">
          <i class="pi pi-users"></i>
          Script de Llamada Manual
        </h4>
        <p class="section-description text-gray-500 mb-3">
          Guión para que los agentes sigan durante llamadas manuales de cobranza.
        </p>
        
        <div formGroupName="callScript">
          <div class="grid">
            <div class="col-12">
              <div class="flex justify-content-between align-items-center mb-2">
                <label for="callGreeting">Saludo</label>
                <small class="text-gray-500">
                  <i class="pi pi-info-circle"></i> Inicio de la llamada
                </small>
              </div>
              <textarea 
                id="callGreeting" 
                pInputTextarea 
                formControlName="greeting" 
                rows="2"
                placeholder="Ej: Buenos días/tardes, ¿hablo con el titular de la cuenta?"
                class="w-full"
                (focus)="setActiveField('callScript.greeting', $event)"
                (click)="updateCursorPosition()"
                (keyup)="updateCursorPosition()"
              ></textarea>
            </div>
            
            <div class="col-12 mt-3">
              <div class="flex justify-content-between align-items-center mb-2">
                <label for="callMainMessage">Mensaje Principal</label>
                <small class="text-gray-500">
                  <i class="pi pi-info-circle"></i> Cuerpo del mensaje
                </small>
              </div>
              <textarea 
                id="callMainMessage" 
                pInputTextarea 
                formControlName="mainMessage" 
                rows="4"
                placeholder="Ej: Le llamamos para recordarle su pago pendiente..."
                class="w-full"
                (focus)="setActiveField('callScript.mainMessage', $event)"
                (click)="updateCursorPosition()"
                (keyup)="updateCursorPosition()"
              ></textarea>
            </div>
            
            <div class="col-12 mt-3">
              <div class="flex justify-content-between align-items-center mb-2">
                <label for="callClosing">Despedida</label>
                <small class="text-gray-500">
                  <i class="pi pi-info-circle"></i> Cierre de la llamada
                </small>
              </div>
              <textarea 
                id="callClosing" 
                pInputTextarea 
                formControlName="closing" 
                rows="2"
                placeholder="Ej: ¿Tiene alguna duda? Estamos para ayudarle. Que tenga buen día."
                class="w-full"
                (focus)="setActiveField('callScript.closing', $event)"
                (click)="updateCursorPosition()"
                (keyup)="updateCursorPosition()"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      
    </p-tabPanel>
    
  </p-tabView>
</form>
  </div>
  
  <!-- COLUMNA DERECHA: Variables Panel (sticky, siempre visible) -->
  <div class="variables-column">
    <div class="variables-panel-sticky" [class.disabled]="!canInsertVariables">
      <h3 class="panel-title">
        <i class="pi pi-code"></i>
        Variables Disponibles
      </h3>
      
      <!-- Estado deshabilitado en tab "Información Básica" -->
      <div *ngIf="!canInsertVariables" class="panel-disabled-message">
        <i class="pi pi-lock"></i>
        <p>Las variables están disponibles en las pestañas de canales de comunicación</p>
        <small>Haz clic en Email, SMS, WhatsApp o Llamadas para usar variables dinámicas</small>
      </div>
      
      <!-- Estado normal: con campos activos -->
      <div *ngIf="canInsertVariables">
        <!-- Indicador de campo activo -->
        <div *ngIf="activeFieldPath" class="active-field-indicator">
          <i class="pi pi-circle-fill"></i>
          Insertando en: <strong>{{ getFieldLabel(activeFieldPath) }}</strong>
        </div>
        
        <!-- Mensaje cuando no hay campo seleccionado -->
        <div *ngIf="!activeFieldPath" class="no-field-selected">
          <i class="pi pi-info-circle"></i>
          Haz clic en un campo de texto para insertar variables
        </div>
        
        <!-- Picker de variables (único en toda la página) -->
        <app-variable-picker 
          (onVariableSelected)="insertVariableInActiveField($event)">
        </app-variable-picker>
      </div>
    </div>
  </div>
</div>
